export default __webpack_public_path__ + "4e0d091d04727ec866b4fc5132d294e8.png";